import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import {
  brandColours,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
} from '../styles';
import { ArrowButton, Container, Heading, Overline } from './ui';
import CaseStudyCard from './CaseStudyCard';

const StyledFeaturedCaseStudies = styled.section`
  ${sectionPaddings('60px', '120px')};
  background-color: ${brandColours.quaternary};
`;

const StyledOverline = styled(Overline)`
  color: ${brandColours.senary};
`;

const StyledInner = styled.div`
  margin-top: 28px;
  display: grid;
  row-gap: 15px;

  ${minBreakpointQuery.smedium`
    margin-top: 32px;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 60px;
  `}
`;

const StyledHeading = styled(Heading)`
  color: ${standardColours.white};
`;

const StyledItems = styled.div`
  display: grid;
  gap: 15px;

  ${minBreakpointQuery.smedium`
    grid-row: 2;
    grid-column-start: 1;
    grid-column-end: 4;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  `}
`;

const StyledButton = styled(ArrowButton)`
  margin-left: auto;
  margin-top: auto;
  color: ${standardColours.white};
  background-color: ${standardColours.transparent};
  border: solid 1px ${brandColours.nonary};

  ${maxBreakpointQuery.smedium`
     margin-right: auto;
     margin-top: 15px;
  `}

  &:hover {
    background-color: ${brandColours.secondary};
    border-color: ${brandColours.secondary};
    color: ${standardColours.white};
  }

  &:before {
    filter: none;
  }
`;

const FeaturedCaseStudies = ({ heading, items }) => {
  const { datoCmsCaseStudyListing } = useStaticQuery(graphql`
    query FeaturedCaseStudiesQuery {
      datoCmsCaseStudyListing {
        slug
      }
    }
  `);

  return (
    <StyledFeaturedCaseStudies>
      <Container>
        <StyledOverline>Case studies</StyledOverline>
        <StyledInner>
          <StyledHeading>{heading}</StyledHeading>
          <StyledItems>
            {items.map((item, id) => (
              <CaseStudyCard key={id} {...item} />
            ))}
          </StyledItems>
          <StyledButton to={datoCmsCaseStudyListing.slug}>
            View all cases
          </StyledButton>
        </StyledInner>
      </Container>
    </StyledFeaturedCaseStudies>
  );
};

export default FeaturedCaseStudies;
